export default __webpack_public_path__ + "static/media/NEAS0620.34I-38118_-22430_0.46ad741d.jpg";